const API_CONFIG = {
  BASE_URL: 'https://orgi-trial-api.sconexsoft.com/orgi',//PROD 2
  // BASE_URL: 'https://orgi-api.sconexsoft.com/orgi',  //PROD 1
  // BASE_URL: 'https://orgi-dev-api.sconexsoft.com/orgi',//DEV
  SERVICE_URL: 'https://s3service.sconexsoft.com',
  RECALCULATION_BASE_URL:'https://orgi-trial-api.sconexsoft.com',

  ENDPOINTS: {
    AUTH: {
      LOGIN: '/api/v1/auth',
      REGISTER: '/api/register',
      ROLES:'/api/roles',
      FORGOT_PASSWORD: '/api/forgot-password',
      VERIFY_OTP: '/api/verify-otp',
      RESET_PASSWORD: '/api/reset-password'
    },
    BATCH_TRANSACTIONS: {
      GROUPED: 'batch-transactions/abstractview',
      GROUPED_BY_PRODUCT: 'batch-transactions/abstractview/:runId/:productId/:companyName/:brandName',
      PRODUCTS_BY_IMAGE: '/batch-transactions/products-by-image/:runId/:imageName',
    },
    DETAILED_VIEW: {
      IMAGE_COUNT: '/detailed-view/image-summary',
    },
    PRODUCT_COMPANIES: '/product-companies',
    MODEL_DETAILS: 'model-details',
    MODEL_REPORT: {
      MATCHED_SKU_COUNT: 'model-evaluation/matchedsku-count/:model/:iteration',
      DETAIL: 'model-evaluation/detailed-view/:model/:iteration',
    },
    MODEL_EVALUATION: {
      DISTINCT_ITERATIONS: 'model-details/distinct-iterations/:model',
      ABSTRACT_COUNTS: 'model-evaluation/abstract-counts/:model/:iteration',
      PRODUCTS: 'model-evaluation/abstract-counts/products/:model/:iteration',
      BRANDS: 'model-evaluation/abstract-counts/brands/:model/:iteration',
      PACK_TYPES: 'model-evaluation/abstract-counts/pack-types/:model/:iteration',
      PACK_SIZES: 'model-evaluation/abstract-counts/pack-sizes/:model/:iteration',
      SKU_DETAILS: 'model-evaluation/sku-details/:model/:iteration/:sku',
    },
    SOURCE_DETAILS: {
      FILE_NAMES: 'source-details/file-names',
      PRODUCT_NAMES: 'source-details/product-names',
      BY_IMAGE: 'source-details/:imageName',
      GET_CLASS_ID: 'source-details/get-classId',
      ADD_RECORD: 'source-details/add-record',
      DELETE_RECORD: 'source-details/delete-record',
      UPDATE_RECORD: 'source-details/sourcetable/update/:actualFileName/:classId',
    },
    ANALYTICS: {
      BRAND_COUNTS: 'analytics/brand-counts',
      PACKSIZE_COUNTS: 'analytics/packsize-counts',
      PRODUCTS_COUNTS: 'analytics/product-counts',
    },
    RUNTIME: '/runstatus',
    STATUS: {
      ACTIVE: 'status/active',
      INACTIVE: 'status/inactive',
    },
    VISIBILITY_ITEMS: '/visibility-items',
    VISIBILITY_ITEMS_1: 'target-visibility-items/:model/:iteration',
    EXECUTIVE_COUNT: {
      DATES: 'file-upload/data/dates',
      CATEGORY_WISE: 'file-upload/data/categorywise?date=:date',
      STORE_WISE: 'file-upload/data/storewise?date=:date',
      EXECUTIVE_CATEGORY: 'file-upload/data/executivewise?date=:date',
      EXECUTIVE_IMAGE: 'file-upload/data/executivewisecount?date=:date',
    },
    STORE_REPORT: {
      RECALCULATION:'/aicalc/calculate-score',
       SCORES:'/red-master/store-scores',
       STORE_SEARCH:'/red-master/store-search',
       CITYDP:'/red-master/asm-cities',
       CHANNELDP:'/red-master/channels',
       UPDATE:'/batch-transactions/update-product',
       GET_PRODUCTS:'/batch-transactions/get-product',
       ACTIVATION:{
          PRODUCTS:"/product-master/activation-products",
          DELETE:"/visibility-items/delete-product",
          UPDATE:"/visibility-items/update/",
          ADD:"/visibility-items/add-product",
          IMAGES:"/v1/file-upload/activation-images",
       }
    },
    REPORT_CENTER:{
      STORERAWDATA:'/api/store-raw-data',
      SOVIREPORT:'/api/sovi-report',
      MANUAL_STORE_AUDIT:'/api/manual-store-audit-report',
      AUDIT_DATA_TRACKING:'/api/store-audit-data-report',
    },

    RED_SCORE: 'red-score',
    ASM_REPORT: {
      REGIONDP: "/red-master/regions",
      SUBREGIONDP: "/red-master/sub-regions",
      CITYDP: "/red-master/cities",
      CHANNELDP: "/red-master/channels",
      TYPEDP: "/red-master/store-types",
      MANAGERS: "/red-master/asm-details",
      SCORES: "/red-master/scores",
      ASM: "/red-master/search",
      ASMNAMES: "/red-master/asm-cities",
      ChannelScores: "/red-master/graph-scores",
      DISTRIBUTOR: "/red-master/distributor-details",
      SO_STORES:"/red-master/stores",
      ABSTRACTVIEW:"/red-master/store-details",//same as store report abstract view
      },

  
    DASHBOARD: '/dashboard/analytics/audited-stores',
    // STOREADUITED: '/red-score/audited-stores'
    VISICOOLER: {
      ASMDP: "/red-master/dropdown",
      STORE_WISE_IMAGES:'/v1/file-upload/cooler-images'
    },
    MODAL_RESULTS:{
      ITERATIONS:'/api/model-results/iterations',
      STORES:'api/model-results/stores',
      PRODUCT_DETAILS:'/api/model-results/product-details'
    },
    VARIANCE_REPORT:{
      AVAILABILITY:'/api/availability/stores',
      },
    VARIANCE_REPORT_AI_VS_MANUAL:{
      AVAILABILITY: '/api/reports/availability-variance/summary',
      ACTIVATION_MANUAL_OUTPERFORMS: '/api/reports/activation-variance/manual-outperforms',
      ACTIVATION_AI_OUTPERFORMS: '/api/reports/activation-variance/ai-outperforms',
      COOLERPURITY:'/api/reports/cooler-purity-variance/manual-pass-ai-fail',
      COOLERPURITY_AI_FAIL:'/api/reports/cooler-purity-variance/manual-fail-ai-pass'
      },

    RED_FRESHNESS: {
      REPORT: '/api/red-freshness/report',
    },
    STORE_ABSTRACT: {
      REPORT: '/api/abstract-store-report',
    },
    ROLE_BASED_ACCESS: {
      ROLES: '/api/roles',
      ROLE_MENU: '/api/role-menu',
    },
    UnResolved_products:'/api/unresolved-products',
    DIS_REPORT: {
      DATA: 'v1/file-upload/daily-upload-status',
    },
    MANUALSHELFCOUNTS:{
      STORES: '/api/reports/manualstorescount',
      AUDITORS: '/api/reports/ai-vs-manual/auditors',
      AI_VS_MANUAL_REPORT: '/api/reports/ai-vs-manual/not-checked',
      AI_VS_MANUAL_REPORT_CHECKED: '/api/reports/ai-vs-manual/checked',
      AI_VS_MANUAL_REPORT_BY_AUDITOR: '/api/reports/ai-vs-manual/by-auditor',
      VALIDATE_STORE: '/api/audit/validate-store',
      UPDATE_SHELF_REPORT: '/batch-transactions/update-shelf-report',
      AVAILABILITY_PRODUCTS: '/product-master/availability-products',
    },
    MASTERSHEETS:{
      SCORETYPEDROPDOWN:'/v1/score-types',
      UPLOAD:'/v1/store-details/upload',
      UPLOAD_LOG:'/v1/store-details/upload-log'
    }

  },
};

export default API_CONFIG;